export default __webpack_public_path__ + "static/media/opsgenie.006321d3.svg";